var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileNotchTablet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 0.75H2.25C1.26562 0.75 0.5 1.54297 0.5 2.5V13C0.5 13.9844 1.26562 14.75 2.25 14.75H11C11.957 14.75 12.75 13.9844 12.75 13V2.5C12.75 1.54297 11.957 0.75 11 0.75ZM11.4375 13C11.4375 13.2461 11.2188 13.4375 11 13.4375H2.25C2.00391 13.4375 1.8125 13.2461 1.8125 13V2.5C1.8125 2.28125 2.00391 2.0625 2.25 2.0625H11C11.2188 2.0625 11.4375 2.28125 11.4375 2.5V13ZM7.5 11.6875H5.75C5.50391 11.6875 5.3125 11.9062 5.3125 12.125C5.3125 12.3711 5.50391 12.5625 5.75 12.5625H7.5C7.71875 12.5625 7.9375 12.3711 7.9375 12.125C7.9375 11.9062 7.71875 11.6875 7.5 11.6875Z",
    fill: "#808B9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileNotchTablet);
export default __webpack_public_path__ + "static/media/mobile-notch-tablet.43c3d4222f10378c10f9c502b7411329.svg";
export { ForwardRef as ReactComponent };